import { render, staticRenderFns } from "./AntiProjectData.vue?vue&type=template&id=092a0337&scoped=true&"
import script from "./AntiProjectData.vue?vue&type=script&lang=js&"
export * from "./AntiProjectData.vue?vue&type=script&lang=js&"
import style0 from "./AntiProjectData.vue?vue&type=style&index=0&id=092a0337&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092a0337",
  null
  
)

export default component.exports